import TripReviewGiftFormView from './trip-review-gift-view';

export default TripReviewGiftFormView;
